import React from "react";
import "./footer.css";
import { FaGithub, FaLinkedin, FaTwitter, FaInstagram } from "react-icons/fa";
import { contact, logo } from "../../utils";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo-section">
          <img src={logo} alt="Logo" className="footer-logo" />
          <div className="footer-social-icons">
            <a
              href={contact.github.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGithub />
            </a>
            <a
              href={contact.linked_in.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin />
            </a>
            <a
              href={contact.twitter.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>
          </div>
        </div>

        <div className="footer-copyright">
          <p className="m-0">© {new Date().getFullYear()} Safi's portfolio</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
